import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import MarketplacePage from "./pages/MarketplacePage";
import CardDetailPage from "./pages/CardDetailPage";
import SellPage from "./pages/SellPage";
import DashboardPage from "./pages/DashboardPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import ProfilePage from "./pages/ProfilePage";
import OrdersPage from "./pages/OrdersPage";
import SalesPage from "./pages/SalesPage";
import MembershipBenefitsPage from "./pages/MembershipBenefitsPage";
import AboutUsPage from "./pages/AboutUsPage";
import AICardScannerPage from "./pages/AICardScannerPage";
import CollectionPage from "./pages/CollectionPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import MessagesPage from "./pages/MessagesPage";
import EditListingPage from "./pages/EditListingPage";
import MyListingsPage from "./pages/MyListingsPage";
import SellerHubPage from "./pages/SellerHubPage";
import MyInventoryPage from "./pages/MyInventoryPage";
import WatchlistPage from "./pages/WatchlistPage";
import AdminPage from "./pages/AdminPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import NotFoundPage from "./pages/NotFoundPage";
import LegalPage from "./pages/LegalPage";
import QAPage from "./pages/QAPage";
import AuctionListPage from "./pages/AuctionListPage";
import LiveAuctionPage from "./pages/LiveAuctionPage";
import SellersHubPage from "./pages/SellersHubPage";
import SettingsPage from "./pages/SettingsPage";
import TrustSafetyPage from "./pages/TrustSafetyPage";
import MarketplaceRulesPage from "./pages/MarketplaceRulesPage";
import AIChatbot from "./components/AIChatbot";
import CommunityHub from "./pages/CommunityHub";
import MobileBottomNav from "./components/MobileBottomNav";
import CheckoutPage from "./pages/CheckoutPage";
import SimpleCartPage from "./pages/SimpleCartPage";

function App() {
  return (
    <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/cards/:id" element={<CardDetailPage />} />
            <Route path="/cart" element={<SimpleCartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/sell" element={<SellPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/:id" element={<OrderDetailPage />} />
            <Route path="/sales" element={<SalesPage />} />
            <Route path="/profile/:id" element={<ProfilePage />} />
            <Route path="/membership" element={<MembershipBenefitsPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/scanner" element={<AICardScannerPage />} />
            <Route path="/collection" element={<CollectionPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/edit-listing/:id" element={<EditListingPage />} />
            <Route path="/my-listings" element={<MyListingsPage />} />
            <Route path="/seller-hub" element={<SellerHubPage />} />
            <Route path="/my-inventory" element={<MyInventoryPage />} />
            <Route path="/watchlist" element={<WatchlistPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin-dashboard" element={<AdminDashboardPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/qa" element={<QAPage />} />
            <Route path="/auctions" element={<AuctionListPage />} />
            <Route path="/auction/:auctionId" element={<LiveAuctionPage />} />
            <Route path="/sellers" element={<SellersHubPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/trust" element={<TrustSafetyPage />} />
            <Route path="/rules" element={<MarketplaceRulesPage />} />
            <Route path="/community" element={<CommunityHub />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Toaster 
            position="top-right" 
            theme="dark"
            toastOptions={{
              style: {
                background: '#18181B',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#FAFAFA',
              }
            }}
          />
          <AIChatbot />
          <MobileBottomNav />
        </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
